// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fedex-address-grid[data-v-08009828]{display:grid;grid-template-columns:1fr;gap:4px 16px}@media(min-width:600px){.fedex-address-grid[data-v-08009828]{grid-template-columns:1fr 1fr}}@media(min-width:600px){.fedex-address-grid__full[data-v-08009828]{grid-column:1/-1}}.fedex-address-grid .v-input--checkbox[data-v-08009828]{width:-moz-max-content;width:max-content}", ""]);
// Exports
module.exports = exports;
